module.exports = __webpack_public_path__ + "img/weibo.d570b5f7.png";